import { zipToObject } from "radashi";
import { Environment, isProdLike } from "../env.js";
import { printLog } from "./printLog.js";

export type LogLevel = "debug" | "error" | "info" | "warn";

const SORTED_LOG_LEVELS: LogLevel[] = ["debug", "info", "warn", "error"];
const LOG_LEVELS_ORDER: Record<LogLevel, number> = zipToObject(
  SORTED_LOG_LEVELS,
  SORTED_LOG_LEVELS.map((_, index) => index + 1),
);

type LoggerOptions = {
  environment?: Environment;
  level?: LogLevel;
};

export const getLogger = ({
  environment = "development",
  level = "debug",
}: LoggerOptions) => ({
  debug(...args: Parameters<Console["debug"]>) {
    if (this.shouldLog("debug")) {
      printLog("debug", ...args);
    }
  },

  error(...args: Parameters<Console["error"]>) {
    if (this.shouldLog("error")) {
      printLog("error", ...args);
    }
  },

  info(...args: Parameters<Console["info"]>) {
    if (this.shouldLog("info")) {
      printLog("info", ...args);
    }
  },

  log(...args: Parameters<Console["info"]>) {
    if (this.shouldLog("info")) {
      printLog("info", ...args);
    }
  },

  shouldLog(logLevel: LogLevel) {
    if (isProdLike(environment)) {
      return false;
    }
    return LOG_LEVELS_ORDER[logLevel] >= LOG_LEVELS_ORDER[level];
  },

  warn(...args: Parameters<Console["warn"]>) {
    if (this.shouldLog("warn")) {
      printLog("warn", ...args);
    }
  },
});

export function isLogLevel(value?: string): value is LogLevel {
  return value !== undefined && SORTED_LOG_LEVELS.includes(value as LogLevel);
}
